webpackJsonp([1],{

/***/ "3kH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("rQBB");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImportEdit',
  data: function data() {
    return {
      uploading: false,
      uploadProgress: 0,
      fileUUID: null,
      dataType: 1,
      filename: null,
      processingProgress: 0,
      progressString: '',
      importLogs: [],
      status: 'init',
      importId: null,
      name: '',
      isDestroyed: false
    };
  },

  computed: {
    processing: function processing() {
      return ['importing', 'checking'].includes(this.status);
    },
    processingComplete: function processingComplete() {
      return ['checked_ok', 'checked_error', 'imported', 'import_error'].includes(this.status);
    },
    canEdit: function canEdit() {
      return ['init', 'checked_ok', 'checked_error', 'import_error'].includes(this.status);
    },
    canProcess: function canProcess() {
      return !!(this.name.trim() !== '' && this.fileUUID);
    },
    canDelete: function canDelete() {
      return this.importId !== null && this.canEdit;
    },
    fileURL: function fileURL() {
      if (this.fileUUID) {
        return __WEBPACK_IMPORTED_MODULE_1__api__["q" /* uploadURL */](this.fileUUID);
      }
    },
    title: function title() {
      return 'TSX Data Import – ' + (this.name || 'Untitled');
    }
  },
  created: function created() {
    if (this.$route.params.id !== 'new') {
      this.importId = this.$route.params.id;
      this.monitorImport();
    }
  },
  watch: {
    importId: function importId(val) {
      this.$router.replace('/import/' + val);
    }
  },
  methods: {
    destroyed: function destroyed() {
      this.isDestroyed = true;
    },
    selectFile: function selectFile() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__util__["e" /* selectFiles */]({
        accept: 'application/vnd.ms-excel,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        multiple: false
      }).then(function (files) {
        if (files.length > 0) {
          _this.uploading = true;

          return __WEBPACK_IMPORTED_MODULE_1__api__["p" /* upload */](files[0], function (progress) {
            _this.uploadProgress = progress * 100;
          }).then(function (result) {
            _this.fileUUID = result.uuid;
          }).finally(function () {
            _this.uploading = false;
          });
        }
      }).then(function () {
        if (_this.fileUUID) {
          _this.checkData();
        }
      });
    },
    checkData: function checkData() {
      this.processImport('checking');
    },
    importData: function importData() {
      this.processImport('importing');
    },
    processImport: function processImport(status) {
      var _this2 = this;

      this.status = status;
      this.processingProgress = 0;

      var promise;

      var dataImport = {
        upload_uuid: this.fileUUID,
        name: this.name.trim(),
        data_type: this.dataType
      };

      if (this.importId) {
        dataImport.status = status;
        promise = __WEBPACK_IMPORTED_MODULE_1__api__["o" /* updateImport */](this.importId, dataImport);
      } else {
        promise = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* createImport */](dataImport);
      }

      promise.then(function (dataImport) {
        _this2.importId = dataImport.id;
        // Poll server for progress while import is running
        return _this2.monitorImport();
      });
    },
    monitorImport: function monitorImport() {
      var _this3 = this;

      return poll(function () {
        return __WEBPACK_IMPORTED_MODULE_1__api__["b" /* dataImport */](_this3.importId);
      }, 1000, function (dataImport) {
        if (_this3.isDestroyed) return false;

        if (dataImport.total_rows && dataImport.processed_rows) {
          _this3.processingProgress = dataImport.processed_rows * 100 / dataImport.total_rows;
          _this3.progressString = dataImport.processed_rows.toLocaleString() + ' / ' + dataImport.total_rows.toLocaleString() + ' rows';
        }
        _this3.fileUUID = dataImport.upload_uuid;
        _this3.name = dataImport.name;
        _this3.filename = dataImport.filename;
        _this3.status = dataImport.status;
        _this3.dataType = dataImport.data_type || 1;
        return dataImport.status === 'checking' || dataImport.status === 'importing';
      }).then(function (dataImport) {
        return __WEBPACK_IMPORTED_MODULE_1__api__["c" /* dataImportLog */](dataImport.id);
      }).then(function (importLog) {
        var logs = [];

        importLog.split('\n').forEach(function (line) {
          if (line.length > 0) {
            logs.push({
              message: line,
              level: line.indexOf('ERROR') >= 0 ? 'error' : line.indexOf('WARNING') >= 0 ? 'warning' : line.indexOf('INFO') >= 0 ? 'info' : null
            });
          }
        });

        _this3.importLogs = logs;
      });
    },
    deleteImport: function deleteImport() {
      var _this4 = this;

      if (confirm('Delete import - are you sure?')) {
        __WEBPACK_IMPORTED_MODULE_1__api__["e" /* deleteImport */](this.importId).then(function () {
          _this4.$router.push('/');
        }).catch(function (e) {
          alert('Delete failed');
          return e;
        });
      }
    }
  }
});

function delayPromise(ms, promiseFn) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    setTimeout(function () {
      return resolve(promiseFn());
    }, ms);
  });
}

// Repeatedly polls promises generated by 'promiseFn', as long as 'callback' returns true on the promise result
function poll(promiseFn, delay, callback) {
  return promiseFn().then(function (result) {
    if (callback(result)) {
      return delayPromise(delay, function () {
        return poll(promiseFn, delay, callback);
      });
    } else {
      return result;
    }
  });
}

/***/ }),

/***/ "4h+C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImportList__ = __webpack_require__("uZ8C");
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import * as api from '@/api'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImportHome',
  components: {
    'import-list': __WEBPACK_IMPORTED_MODULE_0__components_ImportList__["a" /* default */]
  },
  data: function data() {
    // var data = { imports: [] }

    // api.dataImports().then((imports) => { data.imports = imports })

    // return data
    return {};
  }
});

/***/ }),

/***/ "6wet":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9xgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"import-list"},[(_vm.status == 'loading')?_c('div',[_c('p',[_vm._v("\n      Loading…\n    ")])]):_vm._e(),_vm._v(" "),(_vm.status == 'error')?_c('div',[_c('p',[_vm._v("\n      Failed to load imports.\n    ")])]):_vm._e(),_vm._v(" "),(_vm.status == 'loaded')?_c('div',[(_vm.imports.length == 0)?_c('p',{staticClass:"table is-fullwidth is-striped is-hoverable"},[_vm._v("\n      None\n    ")]):_vm._e(),_vm._v(" "),(_vm.imports.length > 0)?_c('table',{staticClass:"table is-fullwidth is-striped is-hoverable"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.imports),function(i){return _c('tr',{on:{"click":function($event){_vm.$router.push("import/" + i.id)}}},[_c('td',[_vm._v(_vm._s(i.name))]),_vm._v(" "),_c('td',[_c('timeago',{attrs:{"since":i.created,"auto-update":60}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.humanizeStatus(i.status)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.errors))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.warnings))])])}))]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Created")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Errors")]),_vm._v(" "),_c('th',[_vm._v("Warnings")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DW5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FX5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plot content"},[_c('h3',{staticClass:"title"},[_vm._v("TSX Plots")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to imports")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('table',{staticClass:"table is-fullwidth"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('basic-select',{attrs:{"options":_vm.sourceList,"selected-option":_vm.selectedSource},on:{"select":_vm.onSourceSelect}})],1),_vm._v(" "),_c('td',[_c('basic-select',{attrs:{"options":_vm.taxonList,"selected-option":_vm.selectedTaxon},on:{"select":_vm.onTaxonSelect}})],1),_vm._v(" "),_c('td',[_c('basic-select',{attrs:{"options":_vm.statusList,"selected-option":_vm.selectedStatus},on:{"select":_vm.onStatusSelect}})],1),_vm._v(" "),_c('td',[_c('basic-select',{attrs:{"options":_vm.stateList,"selected-option":_vm.selectedState},on:{"select":_vm.onStateSelect}})],1)])])]),_vm._v(" "),_c('p',[_c('button',{staticClass:"button is-primary",attrs:{"disabled":_vm.loadingData},on:{"click":_vm.updatePlot}},[_vm._v("Update")])]),_vm._v(" "),_c('spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingData),expression:"loadingData"}],attrs:{"size":"large","message":"Loading data...."}}),_vm._v(" "),_c('canvas',{ref:"dotplot"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Source")]),_vm._v(" "),_c('th',[_vm._v("Species")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("State")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kd24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportEdit_vue__ = __webpack_require__("3kH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff15888_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportEdit_vue__ = __webpack_require__("o7OF");
function injectStyle (ssrContext) {
  __webpack_require__("nWhw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ff15888"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff15888_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kq5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_heatmap_js_plugins_leaflet_heatmap_leaflet_heatmap_js__ = __webpack_require__("KVVV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_heatmap_js_plugins_leaflet_heatmap_leaflet_heatmap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_heatmap_js_plugins_leaflet_heatmap_leaflet_heatmap_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_leaflet_easybutton_src_easy_button_js__ = __webpack_require__("+1bC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_leaflet_easybutton_src_easy_button_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_leaflet_easybutton_src_easy_button_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component_dist_index_js__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component_dist_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_slider_component_dist_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__("rQBB");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var subGroups = [{ value: 'None', text: 'All' },
// {value: 'Tropicbirds Frigatebirds Gannets Boobies', text: 'Tropicbirds Frigatebirds Gannets Boobies'},
// {value: 'Gulls Terns Noddies Skuas Jaegers', text: 'Gulls Terns Noddies Skuas Jaegers'},
// {value: 'Rainforest', text: 'Rainforest'},
// {value: 'Penguins', text: 'Penguins'},
{ value: 'Tropical savanna woodland', text: 'Tropical savanna woodland', group: 'Terrestrial' },
// {value: 'Island endemic', text: 'Island endemic'},
// {value: 'Petrels and Shearwaters', text: 'Petrels and Shearwaters'},
// {value: 'Grassland', text: 'Grassland'},
{ value: 'Albatrosses and Giant-Petrels', text: 'Albatrosses and Giant-Petrels', group: 'Marine' }, { value: 'Dry sclerophyll woodland/forest', text: 'Dry sclerophyll woodland/forest', group: 'Terrestrial'
  // {value: 'Arid Woodland/ shrubland', text: 'Arid Woodland/ shrubland'},
  // {value: 'Heathland', text: 'Heathland'},
  // {value: 'Mallee woodland', text: 'Mallee woodland'}
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TSX',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner___default.a, easyButton: __WEBPACK_IMPORTED_MODULE_6_leaflet_easybutton_src_easy_button_js___default.a, vueSlider: __WEBPACK_IMPORTED_MODULE_7_vue_slider_component_dist_index_js___default.a
  },
  data: function data() {
    var data = {
      // group
      groupList: [],
      selectedGroup: { value: 'None', text: 'All' },
      // subgroup
      subGroupList: [],
      selectedSubGroup: subGroups[0],
      subGroupEnabled: true,
      // states
      stateList: [],
      selectedState: { value: 'None', text: 'All' },
      // status auth
      statusAuthorityList: [],
      selectedStatusAuthority: { value: 'Max', text: 'Max' },
      // status
      statusList: [],
      selectedStatus: { value: 'Near Threatened+Vulnerable+Endangered+Critically Endangered', text: 'All (all Near Threatened + Vulnerable + Endangered + Critically Endangered)' },
      // year
      yearList: [],
      selectedYear: { value: '1985', text: '1985' },
      // charts
      dotPlot: null,
      dotPlotDataSet: null,
      // lpi plot
      lpiPlot: null,
      lpiPlotDataSet: null,
      // summayplot
      summaryPlotDataSet: null,
      summaryPlot: null,
      // is loading data
      loadingData: false,
      // need to query LPI rest service
      queryLPIData: true,
      // no data to show
      noData: true,
      // no LPI run to show
      noLPI: false,
      // prioritySelected
      prioritySelected: false,
      // heatmap
      // intensity plot
      loadingMap: false,
      heatmapLayer: null,
      // this stores the data from the API, heatmapDataSet.data contains subset of it
      surveyData: [],
      heatmapDataSet: { max: 0, min: 0, data: [] },
      map: null,
      showFullMap: false,
      sliderRange: [1960, 2017],
      sliderData: {
        eventType: 'auto',
        width: 'auto',
        height: 4,
        dotSize: 14,
        min: 1960,
        max: 2020,
        interval: 1,
        disabled: false,
        show: false,
        lazy: true,
        tooltip: 'always'
      },
      sliderEnabled: false,
      hasAcceptedWarning: localStorage.getItem('hasAcceptedWarning') || false
      // groups
    };data.groupList.push({ value: 'None', text: 'All' });
    data.groupList.push({ value: 'Terrestrial', text: 'Terrestrial' });
    // data.groupList.push({value: 'Wetland', text: 'Wetland'})
    data.groupList.push({ value: 'Marine', text: 'Marine' });
    data.groupList.push({ value: 'Shoreline (migratory)', text: 'Shoreline (migratory)' });
    // data.groupList.push({value: 'Shoreline (resident)', text: 'Shoreline (resident)'})
    // subgroups
    data.subGroupList = subGroups;
    // states filter
    data.stateList.push({ value: 'None', text: 'All' });
    data.stateList.push({ value: 'Australian Capital Territory', text: 'Australian Capital Territory' });
    // data.stateList.push({value: 'Commonwealth', text: 'Commonwealth'})
    data.stateList.push({ value: 'Queensland', text: 'Queensland' });
    data.stateList.push({ value: 'New South Wales', text: 'New South Wales' });
    data.stateList.push({ value: 'Australian Capital Territory+New South Wales', text: 'Australian Capital Territory + New South Wales' });
    data.stateList.push({ value: 'Northern Territory', text: 'Northern Territory' });
    data.stateList.push({ value: 'South Australia', text: 'South Australia' });
    data.stateList.push({ value: 'Western Australia', text: 'Western Australia' });
    data.stateList.push({ value: 'Tasmania', text: 'Tasmania' });
    data.stateList.push({ value: 'Victoria', text: 'Victoria' });
    // status auth
    data.statusAuthorityList.push({ value: 'Max', text: 'Max' });
    data.statusAuthorityList.push({ value: 'EPBC', text: 'EPBC' });
    // data.statusAuthorityList.push({value: 'IUCN', text: 'IUCN'})
    data.statusAuthorityList.push({ value: 'BirdLifeAustralia', text: 'Australian IUCN status' });
    // year
    data.yearList.push({ value: '1985', text: '1985' });
    data.yearList.push({ value: '1990', text: '1990' });
    data.yearList.push({ value: '1995', text: '1995' });
    data.yearList.push({ value: '2000', text: '2000' });
    // status
    data.statusList.push({ value: 'Vulnerable+Endangered+Critically Endangered', text: 'Threatened species (all Vulnerable + Endangered + Critically Endangered)' });
    data.statusList.push({ value: 'Near Threatened+Vulnerable+Endangered+Critically Endangered', text: 'All (all Near Threatened + Vulnerable + Endangered + Critically Endangered)' });
    data.statusList.push({ value: 'Near Threatened', text: 'Near Threatened species (Near Threatened species only)' });
    // data.statusList.push({value: 'Near Threatened', text: 'Near Threatened'})
    // data.statusList.push({value: 'Vulnerable', text: 'Vulnerable'})
    // data.statusList.push({value: 'Endangered', text: 'Endangered'})
    // data.statusList.push({value: 'Critically Endangered', text: 'Critically Endangered'})
    return data;
  },

  mounted: function mounted() {
    var that = this;
    __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.defaults.global.defaultFontSize = 14;
    // ---------- dot plot -------------
    this.dotPlotDataSet = {
      datasets: [{
        label: 'count > 0',
        backgroundColor: '#333',
        borderColor: '#333',
        borderWidth: 1,
        data: [] }, {
        label: 'count = 0',
        backgroundColor: '#ccc',
        borderColor: '#ccc',
        borderWidth: 1,
        data: [] }]
    };
    this.dotPlot = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.Bubble(this.$refs.dotplot.getContext('2d'), {
      data: that.dotPlotDataSet,
      // Configuration options go here
      options: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'point'
        },
        scales: {
          yAxes: [{
            type: 'linear',
            display: true,
            position: 'left',
            scaleLabel: {
              display: true,
              labelString: 'Sites (time series)'
            }
          }],
          xAxes: [{
            type: 'linear'
          }]
        }
      }
    });
    // --------- summary plot ------------
    this.summaryPlotDataSet = {
      datasets: [{
        label: 'Number of taxa',
        xAxisID: 'x-axis-1',
        yAxisID: 'y-axis-1',
        borderColor: '#58899e',
        backgroundColor: '#58899e',
        data: []
      }, {
        label: 'Number of time series',
        xAxisID: 'x-axis-1',
        yAxisID: 'y-axis-2',
        borderColor: '#a3c489',
        backgroundColor: '#a3c489',
        data: []
      }]
      // --------- lpi plot ------------
    };this.lpiPlotDataSet = {
      labels: [],
      datasets: [{
        label: 'TSX',
        borderColor: '#36699e',
        backgroundColor: 'black',
        fill: false,
        pointRadius: 0,
        lineTension: 0,
        data: [] }, {
        label: 'Confidence Interval (low)',
        backgroundColor: 'rgba(230,230,230,0.5)',
        fill: 1,
        pointRadius: 0,
        lineTension: 0,
        borderColor: '#0000',
        borderWidth: 0,
        data: [] }, {
        label: 'Confidence Interval (high)',
        // backgroundColor: '#eee',
        backgroundColor: 'rgba(230,230,230,0.5)',
        fill: 1,
        pointRadius: 0,
        lineTension: 0,
        borderColor: '#0000',
        borderWidth: 0,
        data: [] }]
    };
    this.lpiPlot = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.Line(this.$refs.lpiplot.getContext('2d'), {
      data: that.lpiPlotDataSet,
      // Configuration options go here
      options: {
        responsive: true,
        legend: {
          display: false
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            display: true,
            position: 'left',
            gridLines: {
              drawOnChartArea: true
            },
            ticks: {
              callback: function callback(label, index, labels) {
                // Force labels to always show one decimal place
                return (+label).toFixed(1);
              }
            }
          }]
        }
      }
    });

    // -------intensity plot ----------------
    var baseLayer = __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 5
    });
    // TODO: might need to tweak some of these
    var cfg = {
      'fullscreenControl': true,
      'radius': 0.45,
      'maxOpacity': 0.8,
      'minOpacity': 0.5,
      'blur': 0.75,
      'scaleRadius': true,
      'useLocalExtrema': false,
      latField: 'lat',
      lngField: 'long',
      valueField: 'count',
      gradient: { 0.25: 'rgb(0,94,255)', 0.5: 'rgb(0,0,255)', 0.85: 'rgb(163,0,255)', 1.0: 'rgb(255,0,255)' }
    };
    this.heatmapLayer = new __WEBPACK_IMPORTED_MODULE_5_heatmap_js_plugins_leaflet_heatmap_leaflet_heatmap_js___default.a(cfg);
    this.map = new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.Map('intensityplot', {
      center: new __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.LatLng(-25.917574, 132.702789),
      zoom: 3,
      layers: [baseLayer, this.heatmapLayer]
    });
    // /////////// map control /////////////////////////
    // setupbutton
    /*
    L.easyButton('<strong>&#9881;</strong>', function(buttonArg, mapArg) {
      // do stuff
      console.log('show settings')
    },
    { position: 'bottomleft' }).addTo(that.map)
    */
    __WEBPACK_IMPORTED_MODULE_4_leaflet___default.a.easyButton({
      id: 'expand',
      position: 'bottomleft',
      states: [{
        icon: '<strong style="color: black">&swarr;</strong>',
        stateName: 'small',
        onClick: function onClick(btn, map) {
          btn.state('big');
          that.showFullMap = true;
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
          });
        }
      }, {
        icon: '<strong style="color: black">&nearr;</strong>',
        stateName: 'big',
        onClick: function onClick(btn, map) {
          btn.state('small');
          that.showFullMap = false;
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
          });
        }
      }]
    }).addTo(that.map);
    //
    // this is a hack so that leaflet displays properlly
    setTimeout(function () {
      that.map.invalidateSize();
      console.log('---update plot----');
    }, 2000);
    this.updatePlot();
  },
  watch: {
    selectedGroup: function selectedGroup(val) {
      this.subGroupList = subGroups.filter(function (x) {
        return val.value === 'None' || x.value === 'None' || x.group === val.value;
      });
      if (this.selectedSubGroup && this.selectedSubGroup.group !== val.value) {
        this.selectedSubGroup = subGroups[0];
      }
      this.subGroupEnabled = this.subGroupList.length > 1;
    },
    selectedStatusAuthority: function selectedStatusAuthority(val) {
      if (val.value === 'None') {
        this.selectedStatusDisabled = true;
        this.selectedStatus = { value: 'None', text: 'All' };
      }
    },
    filterParams: function filterParams(val, oldVal) {
      this.queryLPIData = true;
      this.loadingData = false;
      this.updatePlot();
    },
    sliderRange: function sliderRange(range) {
      if (!this.sliderEnabled || this.loadingMap) {
        return;
      }
      var that = this;
      var minYear = range[0];
      var maxYear = range[1];

      this.heatmapDataSet.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(this.surveyData.filter(function (x) {
        return x.year >= minYear && x.year <= maxYear;
      }));
      // var counts = this.heatmapDataSet.data.map(function(x) { return x.count })
      // this.heatmapDataSet.min = min(counts)
      // this.heatmapDataSet.max = max(counts)

      that.heatmapLayer.setData(that.heatmapDataSet);
    }
  },
  computed: {
    filterParams: function filterParams() {
      return this.getFilterParams();
    }
  },
  methods: {
    updatePlot: function updatePlot() {
      var _this = this;

      console.log('Requery lpi data:' + this.queryLPIData);
      this.loadingData = true;
      // clear existing data
      this.dotPlotDataSet.datasets[0].data = [];
      this.dotPlotDataSet.datasets[1].data = [];
      this.summaryPlotDataSet.datasets[0].data = [];
      this.summaryPlotDataSet.datasets[1].data = [];
      this.lpiPlotDataSet.labels = [];
      this.lpiPlotDataSet.datasets[0].data = [];
      this.lpiPlotDataSet.datasets[1].data = [];
      this.lpiPlotDataSet.datasets[2].data = [];
      this.heatmapDataSet.data = [];
      this.surveyData = [];
      // filters
      var filtersStr = this.getFilterString();
      var filterParams = this.getFilterParams();
      filterParams['format'] = 'plot';
      var that = this;
      if (this.queryLPIData) {
        // ping api first
        __WEBPACK_IMPORTED_MODULE_1__api__["h" /* lpiPlot */](filterParams).then(function (data) {
          _this.noData = data['dotplot'].length === 0;

          // console.log('Getting data')
          // console.log(data)
          // dotplot
          var dotPlotData = data['dotplot'];

          dotPlotData.forEach(function (timeSeries, i) {
            timeSeries.forEach(function (value) {
              var year = value[0];
              var count = value[1];
              that.dotPlotDataSet.datasets[count === 0 ? 1 : 0].data.push({
                x: year,
                y: i + 1,
                r: 1
              });
            });
          });
          // summary plot
          // var speciesCountData = data['summary']['species']
          var taxaCountData = data['summary']['taxa'];
          var timeSeriesCountData = data['summary']['timeseries'];
          var year = 0;
          for (year in taxaCountData) {
            that.summaryPlotDataSet.datasets[0].data.push({ 'x': +year, 'y': +taxaCountData[year] });
          }
          for (year in timeSeriesCountData) {
            that.summaryPlotDataSet.datasets[1].data.push({ 'x': +year, 'y': +timeSeriesCountData[year] });
          }
          that.dotPlot.update();
          // this will cause exception as the axis might be change
          // that.summaryPlot.update()
          that.refreshSummaryPlot();
        }).finally(function () {
          that.queryLPIData = false;
          that.loadingData = false;
        });
      }
      // intensity plot
      that.loadingMap = true;
      this.sliderData.show = false;

      // using lpi wide table per Elisa'request
      // filterParams.source = 'lpi_wide_table'

      __WEBPACK_IMPORTED_MODULE_1__api__["f" /* intensityPlot */](filterParams).then(function (data) {
        console.log('--loading map data----');

        var surveyData = [];
        data.forEach(function (timeSeries) {
          var lat = timeSeries[1];
          var long = timeSeries[0];
          var yearCounts = timeSeries[2];
          yearCounts.forEach(function (yearCount) {
            surveyData.push({
              lat: lat,
              long: long,
              count: yearCount[1],
              year: yearCount[0]
            });
          });
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(surveyData); // Prevent Vue trying to observe survey data for changes
        that.surveyData = surveyData;

        if (that.sliderEnabled) {
          var years = Object(__WEBPACK_IMPORTED_MODULE_8__util__["d" /* pluck */])(that.surveyData, 'year');
          that.sliderData.min = Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* min */])(years);
          that.sliderData.max = Object(__WEBPACK_IMPORTED_MODULE_8__util__["b" /* max */])(years);
          that.sliderRange = [that.sliderData.min, that.sliderData.max];
        }

        var counts = Object(__WEBPACK_IMPORTED_MODULE_8__util__["d" /* pluck */])(that.surveyData, 'count');
        that.heatmapDataSet.max = Object(__WEBPACK_IMPORTED_MODULE_8__util__["b" /* max */])(counts);
        that.heatmapDataSet.min = Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* min */])(counts);

        that.heatmapDataSet.data = that.surveyData;
        that.heatmapLayer.setData(that.heatmapDataSet);
        // that.map.invalidateSize()
      }).finally(function () {
        that.loadingMap = false;
        that.sliderData.show = that.sliderEnabled;
      });
      // get files later
      __WEBPACK_IMPORTED_MODULE_1__api__["i" /* lpiRunData */](filtersStr, this.selectedYear.value, 'txt').then(function (data) {
        if (data && data.indexOf('"LPI_final"') === 0) {
          // format:
          // "LPI_final" "CI_low" "CI_low"
          // "1980" float float float

          var plotData = that.lpiPlotDataSet;

          var series = data.split('\n').slice(1) // Ignore first line
          .filter(function (line) {
            return line.trim().length > 0 && !/NA/.test(line);
          }) // Ignore empty or NA lines
          .map(function (line) {
            return line.split(' ');
          });

          plotData.labels = series.map(function (x) {
            return parseInt(x[0].replace(/"/g, ''));
          });
          plotData.datasets[0].data = series.map(function (x) {
            return parseFloat(x[1]);
          });
          plotData.datasets[1].data = series.map(function (x) {
            return parseFloat(x[2]);
          });
          plotData.datasets[2].data = series.map(function (x) {
            return parseFloat(x[3]);
          });

          // update lpi plot
          that.noLPI = false;
          that.lpiPlot.update();
        } else {
          that.noLPI = true;
        }
      }).catch(function (e) {
        console.log(e);
        that.noLPI = true;
      }).finally(function () {
        if (!that.queryLPIData) {
          that.loadingData = false;
        }
      });
    }, // end updatePlot function
    downloadCSV: function downloadCSV() {
      var filterParams = this.getFilterParams();
      filterParams['format'] = 'zip';
      filterParams['download'] = 'tsxdata.zip';
      var url = __WEBPACK_IMPORTED_MODULE_1__api__["g" /* lpiDownloadURL */](filterParams);
      window.open(url);
    },
    viewDataSummary: function viewDataSummary() {
      var filterParams = this.getFilterParams();
      var url = __WEBPACK_IMPORTED_MODULE_1__api__["j" /* lpiSummaryURL */](filterParams);
      window.open(url);
    },
    acceptWarning: function acceptWarning() {
      localStorage.setItem('hasAcceptedWarning', true);
      this.hasAcceptedWarning = true;
    },
    goBack: function goBack() {
      window.history.back();
    },
    getFilterParams: function getFilterParams() {
      var filterParams = { dataset: 'tbx2018' };
      filterParams['reference_year'] = this.selectedYear.value;
      if (this.prioritySelected) {
        filterParams['priority'] = 1;
      } else {
        if (this.selectedGroup.value !== 'None') {
          filterParams['group'] = this.selectedGroup.value;
        }
        if (this.selectedSubGroup.value !== 'None') {
          filterParams['subgroup'] = this.selectedSubGroup.value;
        }
        if (this.selectedState.value !== 'None') {
          filterParams['state'] = this.selectedState.value;
        }
        if (this.selectedStatusAuthority.value !== 'None') {
          filterParams['statusauth'] = this.selectedStatusAuthority.value;
        }
        if (this.selectedStatus.value !== 'None') {
          filterParams['status'] = this.selectedStatus.value;
        }
      }
      return filterParams;
    },
    getFilterString: function getFilterString() {
      var filtersStr = '';
      if (this.prioritySelected) {
        filtersStr = 'priority-1';
      } else {
        if (this.selectedGroup.value !== 'None') {
          filtersStr = filtersStr + 'group-' + this.selectedGroup.value + '_';
        }
        if (this.selectedSubGroup.value !== 'None') {
          filtersStr = filtersStr + 'subgroup-' + this.selectedSubGroup.value + '_';
        }
        if (this.selectedState.value !== 'None') {
          filtersStr = filtersStr + 'state-' + this.selectedState.value + '_';
        }
        if (this.selectedStatusAuthority.value !== 'None') {
          filtersStr = filtersStr + 'statusauth-' + this.selectedStatusAuthority.value + '_';
        }
        if (this.selectedStatus.value !== 'None') {
          filtersStr = filtersStr + 'status-' + this.selectedStatus.value + '_';
        }
      }
      return filtersStr;
    },
    // refresh summary plot
    refreshSummaryPlot: function refreshSummaryPlot() {
      if (this.summaryPlot) {
        this.summaryPlot.destroy();
      }
      // create new one
      this.summaryPlot = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.Scatter(this.$refs.sumplot.getContext('2d'), {
        data: this.summaryPlotDataSet,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          hoverMode: 'nearest',
          intersect: true,
          // title: {
          //   display: true,
          //   text: 'Data Summary'
          // },
          scales: {
            xAxes: [{
              position: 'bottom',
              gridLines: {
                zeroLineColor: 'rgba(0,0,0,1)'
              }
            }],
            yAxes: [{
              type: 'linear',
              display: true,
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'Number of taxa'
              },
              id: 'y-axis-1',
              ticks: {
                // precision: 1 // Doesn't seem to work (contrary to documentation) so we use callback as a workaround
                callback: function callback(label, index, labels) {
                  return Math.floor(label) === label ? label : '';
                }
              }
            }, {
              type: 'linear',
              display: true,
              position: 'right',
              reverse: true,
              id: 'y-axis-2',
              scaleLabel: {
                display: true,
                labelString: 'Number of time series'
              },
              // grid line settings
              gridLines: {
                drawOnChartArea: false
              },
              ticks: {
                // See comment for other axis
                callback: function callback(label, index, labels) {
                  return Math.floor(label) === label ? label : '';
                }
              }
            }]
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c50035_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("DW5J");
function injectStyle (ssrContext) {
  __webpack_require__("6wet")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c50035_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tippy__ = __webpack_require__("ybWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tippy__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_tippy___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Oi24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"import-home"},[_c('h2',{staticClass:"title"},[_vm._v("Data Upload")]),_vm._v(" "),_c('router-link',{staticClass:"button is-primary",attrs:{"to":"/import/new","tag":"button"}},[_vm._v("Import surveys")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Imports in progress")]),_vm._v(" "),_c('import-list'),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Completed imports")]),_vm._v(" "),_c('import-list',{attrs:{"completed":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P6FV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDRa":
/***/ (function(module, exports) {

module.exports = ["just now",["%s second ago","%s seconds ago"],["%s minute ago","%s minutes ago"],["%s hour ago","%s hours ago"],["%s day ago","%s days ago"],["%s week ago","%s weeks ago"],["%s month ago","%s months ago"],["%s year ago","%s years ago"]]

/***/ }),

/***/ "QqET":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plot content"},[_c('div',{staticClass:"tile is-ancestor"},[_c('div',{staticClass:"tile is-2 is-parent"},[_c('div',{staticClass:"tile is-child"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Group")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedGroup),expression:"selectedGroup"}],attrs:{"disabled":_vm.prioritySelected},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedGroup=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Sub-group")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSubGroup),expression:"selectedSubGroup"}],attrs:{"disabled":_vm.prioritySelected || !_vm.subGroupEnabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSubGroup=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.subGroupList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("State / Territory")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedState),expression:"selectedState"}],attrs:{"disabled":_vm.prioritySelected},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedState=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.stateList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Status authority")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStatusAuthority),expression:"selectedStatusAuthority"}],attrs:{"disabled":_vm.prioritySelected},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedStatusAuthority=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.statusAuthorityList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStatus),expression:"selectedStatus"}],attrs:{"disabled":_vm.prioritySelected},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.statusList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Reference year")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedYear),expression:"selectedYear"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.yearList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prioritySelected),expression:"prioritySelected"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.prioritySelected)?_vm._i(_vm.prioritySelected,null)>-1:(_vm.prioritySelected)},on:{"change":function($event){var $$a=_vm.prioritySelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.prioritySelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.prioritySelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.prioritySelected=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"checkbox"}},[_vm._v("National priority species")])]),_vm._v(" "),_c('p',[_c('button',{staticClass:"button is-primary is-small",on:{"click":_vm.downloadCSV}},[_vm._v("Download CSV")])]),_vm._v(" "),_c('p',[_c('button',{staticClass:"button is-primary is-small",on:{"click":_vm.viewDataSummary}},[_vm._v("Data Summary")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingData && !_vm.showFullMap),expression:"loadingData && !showFullMap"}],staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background",staticStyle:{"background":"rgba(0,0,0,0.2)"}}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('section',{staticClass:"modal-card-body"},[_c('spinner',{attrs:{"size":"large","message":"Loading data...."}})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.noData),expression:"!noData"}],staticClass:"tile is-vertical ie11-bugfix"},[_c('div',{staticClass:"tile"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showFullMap),expression:"!showFullMap"}],staticClass:"tile is-parent is-vertical"},[_c('div',{staticClass:"tile is-child card"},[_c('h4',{staticClass:"has-text-black"},[_vm._v("Main index")]),_vm._v(" "),_c('span',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"info-icon icon",attrs:{"data-tippy-html":"#popup-main-index","data-tippy-interactive":"true","data-tippy-arrow":"true","data-tippy-placement":"left"}},[_c('i',{staticClass:"far fa-question-circle"})]),_vm._v(" "),_c('div',{directives:[{name:"tippy-html",rawName:"v-tippy-html"}],staticStyle:{"display":"none"},attrs:{"id":"popup-main-index"}},[_vm._m(0,false,false)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.noLPI),expression:"!noLPI"}],staticClass:"plot-container"},[_c('canvas',{ref:"lpiplot"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noLPI),expression:"noLPI"}],staticClass:"has-text-black"},[_c('p',[_vm._v("No index generated – less than 3 taxa present in the range of reference years.")]),_vm._v(" "),_c('p',[_vm._v("Try changing the reference year to build an index")])])]),_vm._v(" "),_c('div',{staticClass:"tile is-child card"},[_c('h4',{staticClass:"has-text-black"},[_vm._v("Monitoring consistency")]),_vm._v(" "),_c('span',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"info-icon icon",attrs:{"data-tippy-html":"#popup-monitoring-consistency","data-tippy-interactive":"true","data-tippy-arrow":"true","data-tippy-placement":"left"}},[_c('i',{staticClass:"far fa-question-circle"})]),_vm._v(" "),_c('div',{directives:[{name:"tippy-html",rawName:"v-tippy-html"}],staticStyle:{"display":"none"},attrs:{"id":"popup-monitoring-consistency"}},[_c('div',{staticClass:"popup-content"},[_vm._v("\n                    This dot plot shows the particular years for which monitoring data were available. Each row represents a time series where a species/subspecies was monitored with a consistent method at a single site. The dots represent count values for the metric used to quantify the species/subspecies while zeros indicate absences (non-detections) of those species at the site.\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"plot-container"},[_c('canvas',{ref:"dotplot"})])])]),_vm._v(" "),_c('div',{staticClass:"tile is-parent is-vertical"},[_c('div',{staticClass:"tile is-child card map-tile"},[_c('h4',{staticClass:"has-text-black"},[_vm._v("Spatial representativeness")]),_vm._v(" "),_c('span',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"info-icon icon",attrs:{"data-tippy-html":"#popup-spatial-rep","data-tippy-interactive":"true","data-tippy-arrow":"true","data-tippy-placement":"left"}},[_c('i',{staticClass:"far fa-question-circle"})]),_vm._v(" "),_c('div',{directives:[{name:"tippy-html",rawName:"v-tippy-html"}],staticStyle:{"display":"none"},attrs:{"id":"popup-spatial-rep"}},[_c('div',{staticClass:"popup-content"},[_vm._v("\n                  This map shows where threatened species data to calculate this index are recorded in Australia. Light blue indicates less data (fewer sites monitored), pink indicates more data (more sites monitored).\n                ")])]),_vm._v(" "),(_vm.sliderEnabled)?_c('vue-slider',_vm._b({ref:"slider",staticClass:"heatmap-slider",model:{value:(_vm.sliderRange),callback:function ($$v) {_vm.sliderRange=$$v},expression:"sliderRange"}},'vue-slider',_vm.sliderData,false)):_vm._e(),_vm._v(" "),_c('div',{ref:"intensityplot",staticClass:"heatmap-div",attrs:{"id":"intensityplot"}}),_vm._v(" "),_c('spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingMap),expression:"loadingMap"}],staticClass:"heatmap-spinner",attrs:{"size":"medium"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showFullMap),expression:"!showFullMap"}],staticClass:"tile is-child card"},[_c('h4',{staticClass:"has-text-black"},[_vm._v("Time series and species accumulation")]),_vm._v(" "),_c('span',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"info-icon icon",attrs:{"data-tippy-html":"#popup-summary-plot","data-tippy-interactive":"true","data-tippy-arrow":"true","data-tippy-placement":"left"}},[_c('i',{staticClass:"far fa-question-circle"})]),_vm._v(" "),_c('div',{directives:[{name:"tippy-html",rawName:"v-tippy-html"}],staticStyle:{"display":"none"},attrs:{"id":"popup-summary-plot"}},[_c('div',{staticClass:"popup-content"},[_vm._v("\n                  This plot shows the number of species/subspecies (in blue) and the number of time series (in green) used to calculate the index for each year.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"plot-container"},[_c('canvas',{ref:"sumplot"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noData),expression:"noData"}],staticClass:"tile is-child"},[_c('p',{staticStyle:{"margin":"0.8em"}},[_vm._v("(No data to show)")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasAcceptedWarning),expression:"!hasAcceptedWarning"}],staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button",on:{"click":_vm.acceptWarning}},[_vm._v("I Accept")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":_vm.goBack}},[_vm._v("Cancel")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-content"},[_c('p',[_vm._v("The index shows the average change in populations compared to a base year. It shows a relative change and not population numbers themselves. At the reference year, the index gets an index score of one. A score of 1.2 would mean a 20% increase on average compared to the reference year, while a score of 0.8 would mean a 20% decrease on average compared to the reference year.")]),_vm._v(" "),_c('p',[_vm._v("Check this index:")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("Look at "),_c('b',[_vm._v("Spatial representativeness")]),_vm._v(" map to see how much data there are and where these data come from.")]),_vm._v(" "),_c('li',[_vm._v("Look at "),_c('b',[_vm._v("Monitoring consistency")]),_vm._v(" to see how consistently each monitoring location was visited over time.")]),_vm._v(" "),_c('li',[_vm._v("Go to "),_c('b',[_vm._v("Time series and species accumulation")]),_vm._v(" plot to see how many time series and species/subspecies were used to calculate this index in each year")]),_vm._v(" "),_c('li',[_vm._v("Adjust the "),_c('b',[_vm._v("Reference year")]),_vm._v(" to let the index start at a year with more data")]),_vm._v(" "),_c('li',[_vm._v("Go to "),_c('b',[_vm._v("Data Summary")]),_vm._v(" to see which species/subspecies were included in this index")]),_vm._v(" "),_c('li',[_vm._v("Go to "),_c('b',[_vm._v("Download CSV")]),_vm._v(" to get the aggregated data used to calculate this index.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-card-head"},[_c('span',{staticClass:"modal-card-title"},[_vm._v("Caution")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal-card-body",staticStyle:{"color":"black"}},[_c('p',[_vm._v("The trends produced by this tool vary in reliability.")]),_vm._v(" "),_c('p',[_vm._v("A trend is only as good as the data used to generate it.")]),_vm._v(" "),_c('p',[_vm._v("We have developed diagnostic tools to help assess the reliability of each trend. "),_c('a',{attrs:{"target":"_blank","rel":"noopener noreferrer","href":"https://tsx.org.au/visualising-the-index/how-good/"}},[_vm._v("(Click here for more details on how to assess reliability of trends)")])]),_vm._v(" "),_c('p',[_vm._v("By using this tool you acknowledge these precautions and agree to apply common sense whenever using the TSX.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rk/P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sx60":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SyoV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V4CT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportHome_vue__ = __webpack_require__("4h+C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5332546c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportHome_vue__ = __webpack_require__("Oi24");
function injectStyle (ssrContext) {
  __webpack_require__("VOIW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5332546c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5332546c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VNv2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plot_vue__ = __webpack_require__("pGSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2978ffb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plot_vue__ = __webpack_require__("FX5L");
function injectStyle (ssrContext) {
  __webpack_require__("cQ77")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2978ffb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VOIW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VcHB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TSX_vue__ = __webpack_require__("Kq5X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6926812d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TSX_vue__ = __webpack_require__("QqET");
function injectStyle (ssrContext) {
  __webpack_require__("YQWQ")
  __webpack_require__("Sx60")
  __webpack_require__("P6FV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6926812d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TSX_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6926812d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TSX_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xmyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_heatmap_js_plugins_leaflet_heatmap_leaflet_heatmap_js__ = __webpack_require__("KVVV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_heatmap_js_plugins_leaflet_heatmap_leaflet_heatmap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_heatmap_js_plugins_leaflet_heatmap_leaflet_heatmap_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Intensity',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    var data = {
      // group
      groupList: [],
      selectedGroup: { value: 'None', text: 'All' },
      // subgroup
      subGroupList: [],
      selectedSubGroup: { value: 'None', text: 'All' },
      // states
      stateList: [],
      selectedState: { value: 'None', text: 'All' },
      // status auth
      statusAuthorityList: [],
      selectedStatusAuthority: { value: 'Max', text: 'Max' },
      // status
      statusList: [],
      selectedStatus: { value: 'None', text: 'All' },
      // year
      yearList: [],
      selectedYear: { value: '1970', text: '1970' },
      // is loading data
      loadingData: false,
      // need to query LPI rest service
      queryLPIData: true,
      // no data to show
      noData: true,
      // prioritySelected
      prioritySelected: false,
      // heatmap
      // intensity plot1
      heatmapLayer1: null,
      heatmapDataSet1: { max: 0, min: 0, data: [] },
      map1: null,
      // intensity plot2
      heatmapLayer2: null,
      heatmapDataSet2: { max: 0, min: 0, data: [] },
      map2: null
      // groups
    };data.groupList.push({ value: 'None', text: 'All' });
    data.groupList.push({ value: 'Terrestrial', text: 'Terrestrial' });
    data.groupList.push({ value: 'Wetland', text: 'Wetland' });
    data.groupList.push({ value: 'Marine', text: 'Marine' });
    data.groupList.push({ value: 'Shoreline (migratory)', text: 'Shoreline (migratory)' });
    data.groupList.push({ value: 'Shoreline (resident)', text: 'Shoreline (resident)' });
    // subgroups
    data.subGroupList.push({ value: 'None', text: 'All' });
    data.subGroupList.push({ value: 'Tropicbirds Frigatebirds Gannets Boobies', text: 'Tropicbirds Frigatebirds Gannets Boobies' });
    data.subGroupList.push({ value: 'Gulls Terns Noddies Skuas Jaegers', text: 'Gulls Terns Noddies Skuas Jaegers' });
    data.subGroupList.push({ value: 'Rainforest', text: 'Rainforest' });
    data.subGroupList.push({ value: 'Penguins', text: 'Penguins' });
    data.subGroupList.push({ value: 'Tropical savanna woodland', text: 'Tropical savanna woodland' });
    data.subGroupList.push({ value: 'Island endemic', text: 'Island endemic' });
    data.subGroupList.push({ value: 'Petrels and Shearwaters', text: 'Petrels and Shearwaters' });
    data.subGroupList.push({ value: 'Grassland', text: 'Grassland' });
    data.subGroupList.push({ value: 'Albatrosses and Giant-Petrels', text: 'Albatrosses and Giant-Petrels' });
    data.subGroupList.push({ value: 'Dry sclerophyll woodland/forest', text: 'Dry sclerophyll woodland/forest' });
    data.subGroupList.push({ value: 'Arid Woodland/ shrubland', text: 'Arid Woodland/ shrubland' });
    data.subGroupList.push({ value: 'Parrots, Lorikeets, Rosellas, Cockatoos, Corellas', text: 'Parrots, Lorikeets, Rosellas, Cockatoos, Corellas' });
    data.subGroupList.push({ value: 'Heathland', text: 'Heathland' });
    data.subGroupList.push({ value: 'Mallee woodland', text: 'Mallee woodland' });
    // states filter
    data.stateList.push({ value: 'None', text: 'All' });
    data.stateList.push({ value: 'Australian Capital Territory', text: 'Australian Capital Territory' });
    data.stateList.push({ value: 'Commonwealth', text: 'Commonwealth' });
    data.stateList.push({ value: 'Queensland', text: 'Queensland' });
    data.stateList.push({ value: 'New South Wales', text: 'New South Wales' });
    data.stateList.push({ value: 'Northern Territory', text: 'Northern Territory' });
    data.stateList.push({ value: 'South Australia', text: 'South Australia' });
    data.stateList.push({ value: 'Western Australia', text: 'Western Australia' });
    data.stateList.push({ value: 'Tasmania', text: 'Tasmania' });
    data.stateList.push({ value: 'Victoria', text: 'Victoria' });
    // status auth
    data.statusAuthorityList.push({ value: 'Max', text: 'Max' });
    data.statusAuthorityList.push({ value: 'EPBC', text: 'EPBC' });
    data.statusAuthorityList.push({ value: 'IUCN', text: 'IUCN' });
    data.statusAuthorityList.push({ value: 'BirdLifeAustralia', text: 'BifeLife Australia' });
    // year
    data.yearList.push({ value: '1970', text: '1970' });
    data.yearList.push({ value: '1980', text: '1980' });
    data.yearList.push({ value: '1990', text: '1990' });
    data.yearList.push({ value: '2000', text: '2000' });
    // status
    data.statusList.push({ value: 'None', text: 'All' });
    data.statusList.push({ value: 'Near Threatened', text: 'Near Threatened' });
    data.statusList.push({ value: 'Vulnerable', text: 'Vulnerable' });
    data.statusList.push({ value: 'Endangered', text: 'Endangered' });
    data.statusList.push({ value: 'Critically Endangered', text: 'Critically Endangered' });
    return data;
  },

  mounted: function mounted() {
    var that = this;
    // -------intensity plot ----------------
    var baseLayer1 = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 5
    });
    var baseLayer2 = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 5
    });
    // TODO: might need to tweak some of these
    var cfg = {
      'radius': 0.5,
      'maxOpacity': 0.8,
      'minOpacity': 0,
      'blur': 0.75,
      'scaleRadius': true,
      'useLocalExtrema': false,
      latField: 'lat',
      lngField: 'long',
      valueField: 'count'
    };
    this.heatmapLayer1 = new __WEBPACK_IMPORTED_MODULE_3_heatmap_js_plugins_leaflet_heatmap_leaflet_heatmap_js___default.a(cfg);
    this.map1 = new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.Map('intensityplot1', {
      center: new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.LatLng(-20.917574, 142.702789),
      zoom: 4,
      layers: [baseLayer1, this.heatmapLayer1]
    });
    this.heatmapLayer2 = new __WEBPACK_IMPORTED_MODULE_3_heatmap_js_plugins_leaflet_heatmap_leaflet_heatmap_js___default.a(cfg);
    this.map2 = new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.Map('intensityplot2', {
      center: new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.LatLng(-20.917574, 142.702789),
      zoom: 4,
      layers: [baseLayer2, this.heatmapLayer2]
    });

    // this is a hack so that leaflet displays properlly
    setTimeout(function () {
      that.map1.invalidateSize();
      that.map2.invalidateSize();
    }, 2000);
    this.updatePlot();
  },
  watch: {
    selectedGroup: function selectedGroup(val) {
      if (val.value === 'None') {
        this.selectedSubGroupDisabled = true;
        this.selectedSubGroup = { value: 'None', text: 'All' };
      }
    },
    selectedStatusAuthority: function selectedStatusAuthority(val) {
      if (val.value === 'None') {
        this.selectedStatusDisabled = true;
        this.selectedStatus = { value: 'None', text: 'All' };
      }
    },
    filterParams: function filterParams(val, oldVal) {
      this.queryLPIData = true;
      this.loadingData = false;
      this.updatePlot();
    },
    selectedYear: function selectedYear(val) {
      this.updatePlot();
    }
  },
  computed: {
    filterParams: function filterParams() {
      return this.getFilterParams();
    }
  },
  methods: {
    updatePlot: function updatePlot() {
      var _this = this;

      this.loadingData = true;
      // clear existing data
      this.heatmapDataSet1.data = [];
      this.heatmapDataSet1.max = 0;
      this.heatmapDataSet1.min = 10000;
      this.heatmapDataSet2.data = [];
      this.heatmapDataSet2.max = 0;
      this.heatmapDataSet2.min = 10000;
      // filters
      var filterParams = this.getFilterParams();
      var that = this;
      if (this.queryLPIData) {
        // ping api first
        __WEBPACK_IMPORTED_MODULE_0__api__["h" /* lpiPlot */](filterParams).then(function (data) {
          _this.noData = data['dotplot'].length === 0;
          var intensityPlotData = data['intensity'];
          intensityPlotData.forEach(function (timeSerie) {
            that.heatmapDataSet1.data.push({
              'lat': timeSerie[0],
              'long': timeSerie[1],
              'count': timeSerie[2]
            });
            if (timeSerie[2] > that.heatmapDataSet1.max) that.heatmapDataSet1.max = timeSerie[2];
            if (timeSerie[2] < that.heatmapDataSet1.min) that.heatmapDataSet1.min = timeSerie[2];
          });
          that.heatmapLayer1.setData(that.heatmapDataSet1);
          that.map1.invalidateSize();
        }).finally(function () {
          _this.queryLPIData = false;
          that.loadingData = false;
        });
      }
      // intensity plot
      __WEBPACK_IMPORTED_MODULE_0__api__["f" /* intensityPlot */](filterParams).then(function (data) {
        data.forEach(function (timeSerie) {
          that.heatmapDataSet2.data.push({
            'lat': timeSerie[1],
            'long': timeSerie[0],
            'count': timeSerie[2]
          });
          if (timeSerie[2] > that.heatmapDataSet2.max) that.heatmapDataSet2.max = timeSerie[2];
          if (timeSerie[2] < that.heatmapDataSet2.min) that.heatmapDataSet2.min = timeSerie[2];
        });
        that.heatmapLayer2.setData(that.heatmapDataSet2);
        that.map2.invalidateSize();
      });
      // ------- heatmap -------------
    }, // end updatePlot function
    getFilterParams: function getFilterParams() {
      var filterParams = {};
      if (this.prioritySelected) {
        filterParams['priority'] = 1;
      } else {
        if (this.selectedGroup.value !== 'None') {
          filterParams['group'] = this.selectedGroup.value;
        }
        if (this.selectedSubGroup.value !== 'None') {
          filterParams['subgroup'] = this.selectedSubGroup.value;
        }
        if (this.selectedState.value !== 'None') {
          filterParams['state'] = this.selectedState.value;
        }
        if (this.selectedStatusAuthority.value !== 'None') {
          filterParams['statusauth'] = this.selectedStatusAuthority.value;
        }
        if (this.selectedStatus.value !== 'None') {
          filterParams['status'] = this.selectedStatus.value;
        }
      }
      return filterParams;
    },
    getFilterString: function getFilterString() {
      var filtersStr = '';
      if (this.prioritySelected) {
        filtersStr = 'priority-1';
      } else {
        if (this.selectedGroup.value !== 'None') {
          filtersStr = filtersStr + 'group-' + this.selectedGroup.value + '_';
        }
        if (this.selectedSubGroup.value !== 'None') {
          filtersStr = filtersStr + 'subgroup-' + this.selectedSubGroup.value + '_';
        }
        if (this.selectedState.value !== 'None') {
          filtersStr = filtersStr + 'state-' + this.selectedState.value + '_';
        }
        if (this.selectedStatusAuthority.value !== 'None') {
          filtersStr = filtersStr + 'statusauth-' + this.selectedStatusAuthority.value + '_';
        }
        if (this.selectedStatus.value !== 'None') {
          filtersStr = filtersStr + 'status-' + this.selectedStatus.value;
        }
      }
      return filtersStr;
    }
  }
});

/***/ }),

/***/ "YQWQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ImportHome__ = __webpack_require__("V4CT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ImportEdit__ = __webpack_require__("Kd24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Plot__ = __webpack_require__("VNv2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TSX__ = __webpack_require__("VcHB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Intensity__ = __webpack_require__("rEZh");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/import',
    name: 'ImportHome',
    component: __WEBPACK_IMPORTED_MODULE_2__components_ImportHome__["a" /* default */]
  }, {
    path: '/import/:id',
    name: 'ImportEdit',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ImportEdit__["a" /* default */]
  }, {
    path: '/plot',
    name: 'Plot',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Plot__["a" /* default */]
  }, {
    path: '/',
    name: 'TSX',
    component: __WEBPACK_IMPORTED_MODULE_5__components_TSX__["a" /* default */]
  }, {
    path: '/tsx',
    redirect: '/'
  }, {
    path: '/intensity',
    name: 'Intensity',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Intensity__["a" /* default */]
  }]
}));

/***/ }),

/***/ "a4L2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cQ77":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n5Qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ROOT_URL */
/* harmony export (immutable) */ __webpack_exports__["a"] = createImport;
/* harmony export (immutable) */ __webpack_exports__["o"] = updateImport;
/* harmony export (immutable) */ __webpack_exports__["d"] = dataImports;
/* harmony export (immutable) */ __webpack_exports__["b"] = dataImport;
/* harmony export (immutable) */ __webpack_exports__["c"] = dataImportLog;
/* harmony export (immutable) */ __webpack_exports__["k"] = lpidata;
/* harmony export (immutable) */ __webpack_exports__["g"] = lpiDownloadURL;
/* harmony export (immutable) */ __webpack_exports__["j"] = lpiSummaryURL;
/* harmony export (immutable) */ __webpack_exports__["h"] = lpiPlot;
/* harmony export (immutable) */ __webpack_exports__["f"] = intensityPlot;
/* harmony export (immutable) */ __webpack_exports__["i"] = lpiRunData;
/* unused harmony export region */
/* unused harmony export searchtype */
/* harmony export (immutable) */ __webpack_exports__["m"] = species;
/* harmony export (immutable) */ __webpack_exports__["l"] = source;
/* harmony export (immutable) */ __webpack_exports__["n"] = status;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteImport;
/* harmony export (immutable) */ __webpack_exports__["p"] = upload;
/* harmony export (immutable) */ __webpack_exports__["q"] = uploadURL;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__("0Qa9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("rQBB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_underscore__);

 // We can drop this when browser support is better
// import * as util from 'util'



var TSX_URL = 'https://tsx.org.au';
var ROOT_URL = TSX_URL + '/tsxapi';

function createImport(dataImport) {
  return post('/imports', dataImport);
}

function updateImport(id, dataImport) {
  return put('/imports/' + id, dataImport);
}

function dataImports() {
  return get('/imports');
}

function dataImport(id) {
  return get('/imports/' + id);
}

function dataImportLog(id) {
  return get('/imports/' + id + '/log');
}

function lpidata(params) {
  return get('/lpi-data', params);
}

function lpiDownloadURL(params) {
  return ROOT_URL + '/lpi-data?' + __WEBPACK_IMPORTED_MODULE_2__util__["a" /* encodeParams */](params);
}

function lpiSummaryURL(params) {
  return ROOT_URL + '/lpi-data/stats.html?' + __WEBPACK_IMPORTED_MODULE_2__util__["a" /* encodeParams */](params);
}

function lpiPlot(params) {
  return get('/lpi-data/plot', params);
}

function intensityPlot(params) {
  return get('/lpi-data/intensity', params);
}

// TODO: if files are in object stores, update this
function lpiRunData(filterString, year) {
  if (__WEBPACK_IMPORTED_MODULE_3_underscore___default.a.isEmpty(filterString)) {
    filterString = 'statusauth-Max_';
  }

  // URI Encode everything except spaces and pluses because that's how the files are named on the server
  // filterString = filterString.split(' ').map(encodeURIComponent).join(' ')

  var url = encodeURI(TSX_URL + '/lpi_runs/' + filterString + '/nesp_' + year + '_infile_Results.txt');

  console.log(url);

  var xhr = new XMLHttpRequest();
  xhr.open('GET', url);

  // Used for debugging (e.g. in exceptions)
  xhr._meta = {
    url: url,
    method: 'GET'
  };
  xhr.responseType = '';
  xhr.withCredentials = true;

  return xhrPromise(xhr).then(function (xhr) {
    return xhr.responseText;
  });
}

function region() {
  return get('/region');
}

function searchtype() {
  return get('/searchtype');
}

function species() {
  return get('/species');
}

function source() {
  return get('/source');
}

function status() {
  return get('/status');
}

function deleteImport(id) {
  return del('/imports/' + id);
}

function upload(file, progressCallback) {
  // Flask seems to need files to be uploaded as multipart/form-data for some reason..
  var data = new FormData();
  data.append('file', file);

  // Must pass contentType = null for multipart/form-data
  return post('/uploads', data, null, progressCallback).then(function (result) {
    return {
      uuid: result.uuid,
      url: ROOT_URL + '/uploads/' + result.uuid
    };
  });
}

function uploadURL(uuid) {
  return ROOT_URL + '/uploads/' + uuid;
}

function put(url, data, contentType, progressCallback) {
  return putOrPost('PUT', url, data, contentType, progressCallback);
}

function post(url, data, contentType, progressCallback) {
  return putOrPost('POST', url, data, contentType, progressCallback);
}

function putOrPost(method, url, data, contentType, progressCallback) {
  var xhr = new XMLHttpRequest();

  if (!contentType && !(data instanceof FormData)) {
    data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
    contentType = 'application/json';
  }

  xhr.open(method, ROOT_URL + url);
  if (contentType) {
    xhr.setRequestHeader('Content-Type', contentType);
  }
  // xhr.setRequestHeader('Content-Disposition', 'attachment; filename=' + JSON.stringify(file.name));

  if (progressCallback) {
    xhr.upload.addEventListener('progress', function (evt) {
      if (evt.lengthComputable) {
        progressCallback(evt.loaded / evt.total);
      } else {
        progressCallback(-evt.loaded);
      }
    });
  }

  return xhrPromise(xhr, data).then(function (xhr) {
    var response = xhr.responseText;
    try {
      response = JSON.parse(response);
    } catch (e) {}
    return response;
  });
}

function del(url) {
  var xhr = new XMLHttpRequest();
  xhr.open('DELETE', ROOT_URL + url);

  xhr._meta = {
    url: url,
    method: 'DELETE'
  };

  xhr.withCredentials = true;

  return xhrPromise(xhr).then(function (xhr) {
    var response = xhr.responseText;
    try {
      response = JSON.parse(response);
    } catch (e) {}
    return response;
  });
}

function get(url, params) {
  params = params || {};

  var options = params._options || {};
  params = __WEBPACK_IMPORTED_MODULE_3_underscore___default.a.omit(params, '_options');

  if (!__WEBPACK_IMPORTED_MODULE_3_underscore___default.a.isEmpty(params)) {
    url += '?' + __WEBPACK_IMPORTED_MODULE_2__util__["a" /* encodeParams */](params);
  }

  var xhr = new XMLHttpRequest();
  xhr.open('GET', ROOT_URL + url);
  // console.log(ROOT_URL + url)
  // Used for debugging (e.g. in exceptions)
  xhr._meta = {
    url: url,
    method: 'GET',
    params: params,
    options: options
  };

  xhr.responseType = '';
  xhr.withCredentials = true;

  __WEBPACK_IMPORTED_MODULE_3_underscore___default.a.each(options.headers || {}, function (v, k) {
    xhr.setRequestHeader(k, v);
  });

  // var accessToken = util.store.get('accessToken');
  // if(accessToken) {
  //   xhr.setRequestHeader("Authorization", "Bearer " + accessToken);
  // }

  return xhrPromise(xhr).then(function (xhr) {
    var response = xhr.responseText;
    try {
      response = JSON.parse(response);
    } catch (e) {}
    return response;
  });

  // .catch(function(e) {
  //   if(xhr.status == 401) {
  //     return refreshAccessToken().then(() => get(url, params));
  //   }
  // })
}

function xhrPromise(xhr, dataToSend) {
  return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function (resolve, reject) {
    xhr.addEventListener('error', function () {
      reject(XHRError(xhr));
    });
    xhr.addEventListener('load', function (evt) {
      // Check for error
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr);
      } else {
        reject(XHRError(xhr));
      }
    });
    xhr.send(dataToSend);
  });
}

function XHRError(xhr) {
  var url = xhr._meta ? xhr._meta.url : '?';
  var error = new Error('XHR Error ' + xhr.status + ': ' + url);
  error.xhr = xhr;
  return error;
}

/***/ }),

/***/ "nWhw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o7OF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"import-edit content"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/import"}},[_vm._v("Back to imports")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Enter a description for this import")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"input",staticStyle:{"max-width":"30em"},attrs:{"type":"text","disabled":!_vm.canEdit},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Data type")]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataType),expression:"dataType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dataType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":1}},[_vm._v("Type 1")]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("Type 2/3 (Big Data)")])])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Data file")]),_vm._v(" "),(_vm.status == "init")?_c('p',[_c('button',{staticClass:"button",on:{"click":_vm.selectFile}},[_vm._v("Select file")])]):_vm._e(),_c('p',[_vm._v("Tip: the import will run faster if records belonging to the same survey and site are grouped into contiguous rows instead of scattered throughout the file")]),_vm._v(" "),_c('p'),_vm._v(" "),(_vm.uploading)?_c('p',[_vm._v("\n      Uploading\n      "),_c('progress',{staticClass:"progress is-primary is-small",attrs:{"max":"100"},domProps:{"value":_vm.uploadProgress}},[_vm._v(_vm._s(_vm.uploadProgress)+"%")])]):_vm._e(),_vm._v(" "),(_vm.fileURL && _vm.filename && !_vm.uploading)?_c('p',[_vm._v("\n      File uploaded: "),_c('a',{attrs:{"href":_vm.fileURL}},[_vm._v(_vm._s(_vm.filename))])]):_vm._e()]),_vm._v(" "),(_vm.processing)?_c('div',[_c('p',[_vm._v("\n      Processing "+_vm._s(_vm.progressString)+"\n      "),_c('progress',{staticClass:"progress is-primary is-small",attrs:{"max":"100"},domProps:{"value":_vm.processingProgress}},[_vm._v(_vm._s(_vm.processingProgress)+"%")])])]):_vm._e(),_vm._v(" "),(_vm.status == "checked_ok")?_c('div',{staticClass:"notification is-success"},[_vm._v("\n    👍 Looks good! No errors detected. Please review the log below before importing the data.\n  ")]):_vm._e(),_vm._v(" "),(_vm.status == "checked_ok")?_c('p',[_c('button',{staticClass:"button is-primary",on:{"click":_vm.importData}},[_vm._v("Finish importing data")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":_vm.selectFile}},[_vm._v("Upload an edited file")])]):_vm._e(),_vm._v(" "),(_vm.status == "checked_error")?_c('div',{staticClass:"notification is-warning"},[_vm._v("\n    ⚠️ Some issues were detected in the uploaded file. Please check the log below and then upload a new version for checking.\n  ")]):_vm._e(),_vm._v(" "),(_vm.status == "import_error")?_c('div',{staticClass:"notification is-warning"},[_vm._v("\n    ⚠️ Something went wrong while importing data. Please check the log below.\n  ")]):_vm._e(),_vm._v(" "),(_vm.status == "checked_error" || _vm.status == "import_error")?_c('p',[_c('button',{staticClass:"button",on:{"click":_vm.selectFile}},[_vm._v("Upload an edited file")])]):_vm._e(),_vm._v(" "),(_vm.status == "imported")?_c('div',{staticClass:"notification is-success"},[_vm._v("\n    🎉 All data has been imported without errors. See full import log below.\n  ")]):_vm._e(),_vm._v(" "),(_vm.processingComplete)?_c('div',{staticClass:"log"},[_c('h3',[_vm._v("Import log")]),_vm._v(" "),_vm._l((_vm.importLogs),function(log){return _c('code',{class:log.level,staticStyle:{"display":"block"}},[_vm._v("\n      "+_vm._s(log.message)+"\n    ")])})],2):_vm._e(),_vm._v(" "),(_vm.canDelete)?_c('div',[_c('hr'),_vm._v(" "),_c('button',{staticClass:"button is-light",on:{"click":_vm.deleteImport}},[_vm._v("Delete import")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pGSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__("WaEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select__ = __webpack_require__("ZAW5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import * as util from '@/util'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Plot',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a, BasicSelect: __WEBPACK_IMPORTED_MODULE_3_vue_search_select__["BasicSelect"]
  },
  data: function data() {
    var data = {
      // taxon
      taxonList: [],
      selectedTaxon: { value: '0', text: 'All' },
      // source
      sourceList: [],
      selectedSource: { value: '0', text: 'All' },
      // status
      statusList: [],
      selectedStatus: { value: 'None', text: 'All' },
      // states
      stateList: [],
      selectedState: { value: 'None', text: 'All' },
      // chart
      chart: null,
      // chart data
      chartDataSet: null,
      // is loading dataset
      loadingData: false
      // states filter
    };data.stateList.push({ value: 'None', text: 'All' });
    data.stateList.push({ value: 'Australian Capital Territory', text: 'Australian Capital Territory' });
    data.stateList.push({ value: 'Commonwealth', text: 'Commonwealth' });
    data.stateList.push({ value: 'Queensland', text: 'Queensland' });
    data.stateList.push({ value: 'New South Wales', text: 'New South Wales' });
    data.stateList.push({ value: 'Northern Territory', text: 'Northern Territory' });
    data.stateList.push({ value: 'South Australia', text: 'South Australia' });
    data.stateList.push({ value: 'Western Australia', text: 'Western Australia' });
    data.stateList.push({ value: 'Tasmania', text: 'Tasmania' });
    data.stateList.push({ value: 'Victoria', text: 'Victoria' });
    // query data
    __WEBPACK_IMPORTED_MODULE_0__api__["m" /* species */]().then(function (taxonList) {
      data.taxonList = taxonList.map(function (i) {
        return { value: i['spno'], text: i['common_name'] };
      });
      data.taxonList.push({ value: 0, text: 'All' });
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["l" /* source */]().then(function (sourceList) {
      data.sourceList = sourceList.map(function (i) {
        return { value: i['id'], text: i['description'] };
      });
      data.sourceList.push({ value: 0, text: 'All' });
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["n" /* status */]().then(function (statusList) {
      data.statusList = statusList.map(function (i) {
        return { value: i['description'], text: i['description'] };
      });
      data.statusList.push({ value: 'None', text: 'All' });
    });
    return data;
  },

  mounted: function mounted() {
    this.chartDataSet = {
      animation: {
        duration: 10000
      },
      datasets: [{
        label: 'lpi yearly data',
        backgroundColor: '#4dc9f6',
        borderColor: 'black',
        borderWidth: 1,
        data: [] }]
    };
    var ctx = this.$refs.dotplot.getContext('2d');
    var that = this;
    this.chart = new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, {
      type: 'bubble',
      data: that.chartDataSet,
      // Configuration options go here
      options: {
        responsive: true,
        title: {
          display: true,
          text: 'Dot plots'
        },
        tooltips: {
          mode: 'point'
        }
      }
    });
  },
  methods: {
    updatePlot: function updatePlot() {
      var _this = this;

      this.loadingData = true;
      var filterParams = {};
      if (this.selectedTaxon.value !== '0') filterParams['spno'] = this.selectedTaxon.value;
      if (this.selectedSource.value !== '0') filterParams['sourceid'] = this.selectedSource.value;
      if (this.selectedState.value !== 'None') filterParams['state'] = this.selectedState.value;
      if (this.selectedStatus.value !== 'None') filterParams['status'] = this.selectedStatus.value;
      filterParams['format'] = 'dotplot';
      console.log(filterParams);
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0__api__["k" /* lpidata */](filterParams).then(function (data) {
        // console.log('Getting data')
        that.chartDataSet.datasets[0].data = data.map(function (i) {
          return { 'x': +i['year'], 'y': +i['ID'], 'r': 1 };
        });
        that.chart.update();
        _this.loadingData = false;
        // console.log(that.chartDataSet)
      });
    }, // end updatePlot function
    onSourceSelect: function onSourceSelect(aSource) {
      this.selectedSource = aSource;
    }, // end onSourceSelect
    onTaxonSelect: function onTaxonSelect(aTaxon) {
      this.selectedTaxon = aTaxon;
    }, // end onSourceSelect
    onStatusSelect: function onStatusSelect(aStatus) {
      this.selectedStatus = aStatus;
    }, // end onSourceSelect
    onStateSelect: function onStateSelect(aState) {
      this.selectedState = aState;
    }
  }
});

/***/ }),

/***/ "rEZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intensity_vue__ = __webpack_require__("Xmyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26c26f16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intensity_vue__ = __webpack_require__("tx7x");
function injectStyle (ssrContext) {
  __webpack_require__("a4L2")
  __webpack_require__("Rk/P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intensity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26c26f16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intensity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rQBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = encodeParams;
/* harmony export (immutable) */ __webpack_exports__["e"] = selectFiles;
/* unused harmony export CSVToArray */
/* harmony export (immutable) */ __webpack_exports__["d"] = pluck;
/* harmony export (immutable) */ __webpack_exports__["c"] = min;
/* harmony export (immutable) */ __webpack_exports__["b"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);



// Converts a simple query string a=b&c=d&e=f into a javascript object
// Doesn't allow for keys with more than one - last value overwrites previous values for a given key
function parseParams(queryString) {
  var params = {};
  var regex = /([^&=]+)=([^&]*)/g;
  var m;

  while (true) {
    m = regex.exec(queryString);
    if (!m) break;
    params[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
  }
  return params;
}

function encodeParams(params) {
  return __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.chain(params).pairs().map(function (p) {
    return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]);
  }).sort().value().join('&');
}

// Prompts user to select a file
// returns a promise that resolves to the selected file(s)
// options: accept, multiple
function selectFiles(options) {
  options = options || {};
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var input = document.createElement('input');
    input.setAttribute('style', 'display: none');
    input.setAttribute('type', 'file');
    if (options.accept) {
      input.setAttribute('accept', options.accept);
    }
    if (options.multiple) {
      input.setAttribute('multiple', '');
    }
    document.body.appendChild(input);

    input.addEventListener('change', function () {
      resolve(input.files);
      document.body.removeChild(input);
    });
    input.click();
  });
}

function CSVToArray(strData, strDelimiter) {
  // Check to see if the delimiter is defined. If not,
  // then default to comma.
  strDelimiter = strDelimiter || ',';
  // Create a regular expression to parse the CSV values.
  var objPattern = new RegExp(
  // Delimiters.
  '(\\' + strDelimiter + '|\\r?\\n|\\r|^)' +

  // Quoted fields.
  // '(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|' +
  '(?:"([^"]*(?:""[^"]*)*)"|' +

  // Standard fields.
  // '([^\"\\' + strDelimiter + '\\r\\n]*))'
  '([^"\\' + strDelimiter + '\\r\\n]*))', 'gi');
  // Create an array to hold our data. Give the array
  // a default empty first row.
  var arrData = [[]];
  // Create an array to hold our individual pattern
  // matching groups.
  var arrMatches = objPattern.exec(strData);
  // Keep looping over the regular expression matches
  // until we can no longer find a match.
  while (arrMatches) {
    // Get the delimiter that was found.
    var strMatchedDelimiter = arrMatches[1];
    // Check to see if the given delimiter has a length
    // (is not the start of string) and if it matches
    // field delimiter. If id does not, then we know
    // that this delimiter is a row delimiter.
    if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
      // Since we have reached a new row of data,
      // add an empty row to our data array.
      arrData.push([]);
    }
    var strMatchedValue;
    // Now that we have our delimiter out of the way,
    // let's check to see which kind of value we
    // captured (quoted or unquoted).
    if (arrMatches[2]) {
      // We found a quoted value. When we capture
      // this value, unescape any double quotes.
      strMatchedValue = arrMatches[2].replace(new RegExp('\'\'', 'g'), '\'');
    } else {
      // We found a non-quoted value.
      strMatchedValue = arrMatches[3];
    }
    // Now that we have our value string, let's add
    // it to the data array.
    arrData[arrData.length - 1].push(strMatchedValue);
    arrMatches = objPattern.exec(strData);
  }
  // Return the parsed data.
  return arrData;
}

function pluck(array, key) {
  return array.map(function (x) {
    return x[key];
  });
}

function min(array) {
  return array.reduce(function (a, b) {
    return a === undefined || b < a ? b : a;
  }, undefined);
}

function max(array) {
  return array.reduce(function (a, b) {
    return a === undefined || b > a ? b : a;
  }, undefined);
}

/***/ }),

/***/ "tx7x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plot content"},[_c('h3',{staticClass:"title"},[_vm._v("Intensity Plots")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to imports")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"tile is-ancestor"},[_c('div',{staticClass:"tile is-2 is-parent"},[_c('div',{staticClass:"tile is-child"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Group")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedGroup),expression:"selectedGroup"}],attrs:{"disabled":_vm.prioritySelected},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedGroup=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Sub-group")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSubGroup),expression:"selectedSubGroup"}],attrs:{"disabled":_vm.prioritySelected},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSubGroup=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.subGroupList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("State")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedState),expression:"selectedState"}],attrs:{"disabled":_vm.prioritySelected},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedState=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.stateList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Status authority")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStatusAuthority),expression:"selectedStatusAuthority"}],attrs:{"disabled":_vm.prioritySelected},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedStatusAuthority=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.statusAuthorityList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStatus),expression:"selectedStatus"}],attrs:{"disabled":_vm.prioritySelected},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.statusList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Reference year")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedYear),expression:"selectedYear"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.yearList),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option.text))])}))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prioritySelected),expression:"prioritySelected"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.prioritySelected)?_vm._i(_vm.prioritySelected,null)>-1:(_vm.prioritySelected)},on:{"change":function($event){var $$a=_vm.prioritySelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.prioritySelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.prioritySelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.prioritySelected=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"checkbox"}},[_vm._v("Priority Group")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingData),expression:"loadingData"}],staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('section',{staticClass:"modal-card-body"},[_c('spinner',{attrs:{"size":"large","message":"Loading data...."}})],1)])]),_vm._v(" "),_c('div',{staticClass:"tile card"},[_c('div',{ref:"intensityplot1",staticClass:"heatmap-div",attrs:{"id":"intensityplot1"}})]),_vm._v(" "),_c('div',{staticClass:"tile card"},[_c('div',{ref:"intensityplot2",staticClass:"heatmap-div",attrs:{"id":"intensityplot2"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noData),expression:"noData"}],staticClass:"tile is-child"},[_c('p',{staticStyle:{"margin":"0.8em"}},[_vm._v("(No data to show)")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uZ8C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportList_vue__ = __webpack_require__("v11V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35eeaae9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportList_vue__ = __webpack_require__("9xgf");
function injectStyle (ssrContext) {
  __webpack_require__("SyoV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35eeaae9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35eeaae9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v11V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_timeago__ = __webpack_require__("IPdH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_timeago___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_timeago__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_timeago___default.a, {
  name: 'timeago', // component name, `timeago` by default
  locale: 'en-US',
  locales: {
    // you will need json-loader in webpack 1
    'en-US': __webpack_require__("QDRa")
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImportList',
  data: function data() {
    var _this = this;

    var data = {
      imports: [],
      status: 'loading'
    };

    __WEBPACK_IMPORTED_MODULE_0__api__["d" /* dataImports */]().then(function (imports) {
      data.imports = imports.filter(function (i) {
        return i.status === 'imported' === _this.completed;
      }).sort(function (a, b) {
        return b.created.localeCompare(a.created);
      });
      data.status = 'loaded';
    }).catch(function (error) {
      console.log(error);
      data.status = 'error';
    });

    return data;
  },

  methods: {
    humanizeStatus: function humanizeStatus(str) {
      return {
        init: 'Not checked yet',
        checked_ok: 'Checked (OK)',
        checked_error: 'Checked (error)',
        checking: 'Checking',
        importing: 'Importing',
        imported: 'Imported',
        import_error: 'Error during import'
      }[str];
    }
  },
  props: {
    completed: Boolean
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.db5b6979b89daf40b43d.js